export default __webpack_public_path__ + "static/media/Group 27227.d63269f6.svg";